import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { CheckboxAnswerType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderCheckboxGroup } from '../../views/CheckboxGroup';
import { buildAnswers } from '../utils';

const SECTION_KEY_NAME = 'wordsOfInterest';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'wordsOfInterest';

export const wordsOfInterestSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: CheckboxAnswerType[] = [
    { value: '口コミ', checked: false },
    { value: '評判が良い', checked: false },
    { value: '工事実績', checked: false },
    { value: '助成金', checked: false },
    { value: '火災保険', checked: false },
    { value: '工事時期', checked: false },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');
  };
  const applyHandler = (checkedAnswers: Required<CheckboxAnswerType>[]) => {
    const answerText = checkedAnswers.map((answer) => answer.textContents).join(', ');
    const value = checkedAnswers.map((answer) => answer.value).join(', ');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '他に気になるキーワード',
      answer: answerText || '',
      value: value || '',
    });
  };
  const skipHandler = () => {
    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '他に気になるキーワード',
      answer: '選択しないで次へ',
      value: '未選択',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    isVisibleAvatar: true,
    messageElement: (
      <>
        最後になりますが、検索するにあたって他に気になるキーワードはございますか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderCheckboxGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
    applyHandler,
    skipHandler,
  });

  // 回答内容を返却する
  return answer;
};
